import { QueryObserverOptions, useQuery } from "react-query";
import { APIError, APIResponse, API_URL_V3, get } from "../api";

export interface BillNetwork {
  code: string;
  name: string;
}

/**
 * Airtime networks from the provider-agnostic bills layer (/v3/bills).
 * The active upstream provider (VTUGATE, Swyft, ...) is resolved server-side.
 */
function useBillAirtimeProviders(
  options?: QueryObserverOptions<APIResponse<BillNetwork[]>, APIError>
) {
  const {
    data: providers,
    isLoading: fetchingProviders,
    isError: isProvidersError,
    error: providersError,
  } = useQuery<APIResponse<BillNetwork[]>, APIError>(
    "bills-airtime-providers",
    async () =>
      await get(API_URL_V3 + "/bills/airtime/providers", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),
    options
  );

  return {
    providers: providers?.data || [],
    fetchingProviders,
    isProvidersError,
    providersError,
  };
}

export default useBillAirtimeProviders;
